'use strict';

var _require = require('../helpers/is'),
    isObject = _require.isObject;

module.exports = function skip(number) {
  var _this = this;

  if (isObject(this.items)) {
    return new this.constructor(Object.keys(this.items).reduce(function (accumulator, key, index) {
      if (index + 1 > number) {
        accumulator[key] = _this.items[key];
      }

      return accumulator;
    }, {}));
  }

  return new this.constructor(this.items.slice(number));
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/skip.js
// module id = 1710
// module chunks = 2